import { valueToPercent } from "@mui/base";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormField from "../FormField/FormField";
import SelcectForm from "../FormSelect/SelectForm";
import api from "../../../../utils/apidsf";
import { useNavigate } from "react-router-dom";
import { GetToken } from "../../../../actions/userAction";
import swal from "sweetalert";
// css
import "./UserUpdateForm.css";

const UserUpdateForm = ({ data, handleInputChange, handleRawImage }) => {
  const dispatch = useDispatch();
  const naviaget = useNavigate();
  const selector = useSelector((state) => state);
  const [show, setshow] = useState(false);
  const [filetoken, setfiletoken] = useState("");

  const { name, email, image, id, category, phone, role, rawimage } = data;

  useEffect(() => {
    dispatch(GetToken());
  }, []);

  useEffect(() => {
    setfiletoken(selector?.adminReducer?.token);
  }, [selector]);

  const onUpdate = async (e) => {
    e.preventDefault();
    console.log(id);
    try {
      let token = JSON.parse(localStorage.getItem("token"));

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const form = new FormData();
      form.append("file", rawimage);
      await fetch("https://assets.thelexpedia.com//wp-json/wp/v2/media", {
        method: "POST",
        headers: {
          Authorization: `Bearer  ${filetoken}`,
        },
        body: form,
      })
        .then((res) => res.json())
        .then(async (data) => {
          try {
            let valueForUpdate = {
              name: name,
              email: email,
              image: data.source_url,
              category: category,
              phone: phone,
            };

            await api.put(`/admin/${id}`, valueForUpdate, config);
            swal({
              title: "Success!",
              text: "User Updated!",
              icon: "success",
              button: "Ok!",
            }).then((value) => {
              naviaget(`/admin/user-list`);
            });
          } catch (err) {
            console.error(err.response.data.error);

            swal({
              title: "Error",
              text: err.response.data.error,
              icon: "error",
            });
          }
        });
    } catch (err) {
      console.error(err.response.data.error);
      swal({
        title: "Error",
        text: err.response.data.error,
        icon: "error",
      });
    }
  };

  return (
    <form action="" className="admin__userUpdateForm" onSubmit={onUpdate}>
      <div className="userUpdateLeft">
        {show ? (
          <>
            <div className="userUpdateItem">
              <label className="user__label">Image Link</label>
              <input
                type="file"
                onChange={(e) => {
                  handleRawImage(e.target.files[0]);
                }}
              />
            </div>{" "}
          </>
        ) : (
          <>
            <div className="userUpdateItem">
              <div
                style={{
                  display: "flex",
                }}
              >
                <div>
                  <img
                    src={image}
                    style={{
                      height: "140px",
                      width: "200px",
                    }}
                  />
                </div>
                <div>
                  <button
                    onClick={() => {
                      setshow(true);
                    }}
                  >
                    Edit{" "}
                  </button>
                </div>
              </div>
            </div>{" "}
          </>
        )}

        <div className="userUpdateItem">
          <FormField
            type="text"
            label="Name"
            placeholder="Name"
            value={name}
            name="name"
            handleChange={handleInputChange}
          />
        </div>
        <div className="userUpdateItem">
          <FormField
            type="text"
            label="Email"
            placeholder="Email"
            value={email}
            name="email"
            handleChange={handleInputChange}
          />
        </div>
        <div className="userUpdateItem">
          <FormField
            type="text"
            label="Phone No"
            placeholder="Phone No"
            value={phone}
            name="phone"
            handleChange={handleInputChange}
          />
        </div>

        <div>
          <SelcectForm
            label="Category"
            name="category"
            value={category}
            handleChange={handleInputChange}
            optionField={["student", "teacher", "lawyer"]}
          />
        </div>
      </div>
      <div className="userUpdateRight">
        <div className="userUpdateUpload">
          <img className="userUpdateImg" src={image} alt="" />
        </div>
        <button className="userUpdateButton" type="submit">
          Update
        </button>
      </div>
    </form>
  );
};

export default UserUpdateForm;
